module.exports = "<div class=\"main-integrations\">\n    <div class=\"card\">\n        <div class=\"card-header\"  >\n            <a routerLink=\"/integrations/fb\"><h1>Facebook</h1></a>\n          </div>\n      </div>\n      <div class=\"card\">\n          <div class=\"card-header\">\n            <a routerLink=\"/integrations/pippedrive\"><h1>Pippedrive</h1></a>\n            </div>\n        </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/integrations/integrations.component.html
// module id = ./src/app/components/integrations/integrations.component.html
// module chunks = main